// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useMemo} from 'react';
import cn from 'classnames';
import {t_countries} from '../../lib/use_dashboard_data';
import {Proxy_type, t_order, t_orders, t_zone_group} from '../../../../hola/pub/ui/pro/cp/orders';
import {Plan_history_table} from './plan_history_table';
import {is_group_expired, ORDER_TYPE_NAMES} from './utils';
import {Group_table} from './plan_table';

import styles from '../../pages/toolip.io/dashboard.module.less';

interface i_plan_history_props {
    orders?: t_orders;
    groups?: t_zone_group[];
    countries?: t_countries;
}

const TOOLIP_ORDER_TYPES = [Proxy_type.ISP, Proxy_type.ISPPREM, Proxy_type.DDC,
  Proxy_type.SDC, Proxy_type.RES, Proxy_type.UNKNOWN];

export const Plan_history = (props: i_plan_history_props)=>{
    const {orders, groups, countries} = props;
    const has_expired = useMemo(()=>
        has_expired_orders(orders) || groups?.some(is_group_expired),
    [orders, groups]);
    if (!has_expired)
        return null;
    return <Fragment>
        {TOOLIP_ORDER_TYPES.map(product=>{
          const title = ORDER_TYPE_NAMES[product];
          if (!title)
              return <Fragment key={product}/>;
          const product_orders = orders[product];
          if (!product_orders || product_orders.length==0)
              return <Fragment key={product}/>;
          return <div className={cn(styles.table_container,
            styles.plans_content, styles.mb24)}
            key={product}>
              <Plan_history_table type={product} items={product_orders}
                countries={countries}
                title={title} wrapper_cn={styles.table_history}
                hide_recently_expired/>
          </div>;
        })}
        {groups?.filter(g=>is_group_expired(g)).map(g=>{
          const group_title = 'Event & E-commerce Residential proxies';
          return <div className={cn(styles.table_container,
            styles.plans_content, styles.mb40)} key={g._id}>
            <Group_table
              group={g}
              title={group_title}
              wrapper_cn={styles.table_group}
            />
          </div>;
        })}
      </Fragment>;
};

const is_order_expired = (order: t_order)=>{
    return new Date(order.subscription_until) < new Date();
};

const has_expired_orders = (orders?: t_orders)=>{
    return orders && Object.values(orders).some(oo=>oo.some(is_order_expired));
};
